/* eslint-disable react/jsx-key */

import IconLightning from '../icons/icon-lightning.svg?react'
import Color from '../Color.mjs'
import IconInf from '../SF/icon-inf.svg?react'
import IconTime from '../SF/icon-time.svg?react'

export default map => {
    const {subTypeCode} = map.data

    const name = 'BODA1' === subTypeCode ?
        key => ({
            BL: '业务基础能力',
            BT: '交互业务事务能力',
            INF: '接口业务事务能力',
            TIME: '自动业务事务能力',
        })[key]
        :
        key => ({
            BL: '基础程序能力',
            BT: '交互程序能力',
            INF: '接口程序能力',
            TIME: '自动程序能力',
        })[key]

    return [
        [
            'BT',
            name('BT'),
            <IconLightning style={{fill: Color.GOLD}} />
        ],

        [
            'INF',
            name('INF'),
            <IconInf />
        ],

        [
            'TIME',
            name('TIME'),
            <IconTime />
        ],

        [
            'BL',
            name('BL'),
            <IconLightning style={{fill: Color.GREEN}} />
        ],
    ]
}
